import { InitDataType, RunTimeLayoutConfig, history, useModel } from '@umijs/max';
import { ConfigProvider, message } from 'antd';

import { getLocalStorageItem, logoutToLogin } from '@/utils';
import { LOCAL_STORAGE, LOGIN_STATUS, ROUTES } from '@/utils/enums';

import { useChangeNotify } from '@/hooks/useChangeNotify';
import Children from '@/wrappers/children';

import { AvatarDropdown, AvatarName } from './components/RightContent/AvatarDropdown';
import SearchComponent from './components/SearchComponent';
import MenuItem from './components/MenuItem';
import avatar from '@/assets/avatar.svg';
import logo from '@/assets/logo.svg';
import { useBroadcastSync } from 'react-simple-channel';
import { CURRENT_USER_CHANNEL, LOGIN_STATUS_CHANNEL } from '@/constants/broadcast-channel';
import { useEffect } from 'react';
import { loginOut } from '@/utils/utils';
import NoAccessPage from '@/pages/403';
import { startUpdateTimer, getAccessToken } from '@/utils/common/authToken';
import { clearLocalStore } from '@/hooks/useLocalStore';
import { SAAS_LOGS_OPEN } from '@/pages/Ticket/Saas/Detail/context/logs';
import { LOCAL_EMAIL_LOGS_OPEN } from '@/pages/Ticket/Email/Detail/context/logs';
import { LocalStoreModule } from '@/constants/common';
import { clearModuleLocalStore } from '@/hooks/useLocalStore';
import useServerTime from '@/hooks/useServerTime/webWorkerAndSetInterval';
import { initUserId } from '@/utils/common/initUserId';
import { HotkeysProvider } from 'react-hotkeys-hook';

export const BasicLayout: RunTimeLayoutConfig = ({ initialState }: InitDataType) => {

  const { setInitialState } = useModel('@@initialState');

  // 使用跨tab通信的hooks来获取登录状态
  const [loginStatus] = useBroadcastSync(LOGIN_STATUS_CHANNEL, LOGIN_STATUS.EMPTY);

  // 清除2个log日志的缓存
  useEffect(() => {
    clearLocalStore(SAAS_LOGS_OPEN);
    clearLocalStore(LOCAL_EMAIL_LOGS_OPEN);
    clearModuleLocalStore(LocalStoreModule.EmailLogList);
    clearModuleLocalStore(LocalStoreModule.SaaSLogList);
  }, []);

  useServerTime();
  useEffect(() => {
    LOGIN_STATUS.LOGOUT === loginStatus && loginOut();
  }, [loginStatus]);

  const [currentUser] = useBroadcastSync(CURRENT_USER_CHANNEL, null);

  useEffect(() => {
    if (!currentUser) return;
    setInitialState((s: any) => ({ ...s, currentUser }));
  }, [currentUser]);


  // 当用户数据变更后，重新初始化埋点信息
  useEffect(() => {
    initUserId(initialState?.currentUser);
  }, [initialState?.currentUser]);

  useChangeNotify(); // 激活变更通知逻辑
  useEffect(() => {
    startUpdateTimer(); // 激活定时刷新逻辑
  }, []);
  return {
    // actionsRender: () => [<SearchComponent />], // NOTE 2025-09-12 14:50 挪移到 tabsLayout 组件中~
    defaultCollapsed: true,
    breakpoint: false,
    avatarProps: {
      src: avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.en_name,
    //   fontColor: 'rgba(227,227,227,0.2)',
    // },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      const isLogin = getAccessToken();
      // 如果处于登录状态判断用户是否禁用
      if (!isLogin) {
        message.warning('您还未登录，请先登录！');
        logoutToLogin();
        return;
      }

      // 如果判断用户是否禁用
      if (!initialState?.currentUser?.is_on) {
        history.replace(ROUTES.DISABLE);
        return;
      }

      // 跳转到首页
      if (location.pathname === ROUTES.DISABLE) {
        history.replace(ROUTES.HOME);
        return;
      }
    },
    // breadcrumbProps: {
    //   itemRender: (route) => {
    //     console.log('route', route);
    //     // TODO 图标优化，点击菜单，切换图标，给产品提供图标库。
    //     const { linkPath = '', title = '' } = route;
    //     // if (href) {
    //       return <Link to={linkPath}>{title}</Link>;
    //     // }
    //   },
    // },
    // bgLayoutImgList: [
    //   {
    //     src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
    //     left: 85,
    //     bottom: 100,
    //     height: '303px',
    //   },
    //   {
    //     src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
    //     bottom: -68,
    //     right: -45,
    //     height: '303px',
    //   },
    //   {
    //     src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
    //     bottom: 0,
    //     left: 0,
    //     width: '331px',
    //   },
    // ],
    links: [],
    menuHeaderRender: undefined,
    menuContentRender: (SiderMenuProps, defaultDom) => {
      return (
        <ConfigProvider
          wave={{
            disabled: true,
          }}
          theme={{
            token: {
              motion: false,
              motionDurationFast: '0s',
              motionDurationMid: '0s',
              motionDurationSlow: '0s',
            },
          }}
        >
          {defaultDom}
        </ConfigProvider>
      );
    },
    menuItemRender: (menuItemProps, defaultDom) => (
      <MenuItem target={menuItemProps.target} path={menuItemProps.path || '/'}>{defaultDom}</MenuItem>
    ),
    // 自定义 403 页面
    unAccessible: <NoAccessPage />,
    // 增加一个 loading 的状态
    childrenRender: () => <Children />,
    // childrenRender: (children) => {
    //   // if (initialState?.loading) return <PageLoading />;
    //   return (
    //     <ConfigProvider
    //       theme={{
    //         // !NOTE 去掉全局的动画效果
    //         token: { motion: false},
    //         components: {
    //           Input: {
    //             colorTextDisabled: '#222222',
    //           },
    //           // Select: {
    //           //   colorTextDisabled: '#222222',
    //           // },
    //         },
    //       }}
    //     >
    //       <HotkeysProvider>{children}</HotkeysProvider>
    //     </ConfigProvider>
    //   );
    // },
    ...initialState?.settings,
    logo,
  };
};
